<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="!(_array.isArray(operacoes)) || !(operacoes.length)">
    Não foram encontradas operações com os filtros informados.
  </div>

  <div *ngIf="(_array.isArray(operacoes)) && (operacoes.length)">
    <div class="botoes">
    <div class="float-end">
      <button [disabled]="operacoes.length == 0" class="btn btn-secondary botaoMenor" type="button" (click)="btnExportarAmortizacoes()"
        placement="top" ngbTooltip="Exporta as amortizações das operações listadas">
        <i class="fa fa-file"></i> Exportar amortizações</button>
    </div>
    <div class="float-end">
      <button [disabled]="operacoes.length == 0" class="btn btn-secondary botaoMenor" type="button" (click)="btnExportarLiberacoes()"
        placement="top" ngbTooltip="Exporta as liberações das operações listadas">
        <i class="fa fa-file"></i> Exportar liberações</button>
    </div>
    <div class="float-end">
      <button [disabled]="operacoes.length == 0" class="btn btn-secondary botaoMenor" type="button" (click)="btnExportarOperacoes()"
        placement="top" ngbTooltip="Exporta as operações listadas">
        <i class="fa fa-file"></i> Exportar operações</button>
    </div>
    <div class="float-end">
      <button [disabled]="operacoes.length == 0" class="btn btn-secondary botaoMenor" type="button" (click)="btnExportarAditivos()"
        placement="top" ngbTooltip="Exporta aditivos das operações listadas">
        <i class="fa fa-file"></i> Exportar aditivos</button>
    </div>
    </div>
    <div class="letra-miuda">atualizado em: {{ dataHoraResultado }}</div>

    <bn-paginacao [total]="atributosPaginacao.count"
      [tamanhoPagina]="atributosPaginacao.pageSize" 
      [numPagina]="atributosPaginacao.page"
      [opcoesTamanhoPagina]="opcoesPaginacao" 
      (aoMudar)="mudancaPagina($event)">    
      
      <div class="table-responsive">
        <table class="table table-hover fonte">
          <thead>
            <tr >
              <th *ngIf="!ehAgenteFinanceiro" id="col-age" scope="col">
                <bn-ordenacao 
                  [ordenacao]="atributosOrdenacao" 
                  [atributo]="'nome'"
                  [nomeAtributoExibicao]="'Agente financeiro'" 
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-id" scope="col">
                <bn-ordenacao 
                  [ordenacao]="atributosOrdenacao" 
                  [atributo]="'ide'"
                  [nomeAtributoExibicao]="'ID'" 
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-id_ext" scope="col">                
                <bn-ordenacao 
                  [ordenacao]="atributosOrdenacao" 
                  [atributo]="'identificadorProtocoloOperacao'"
                  [nomeAtributoExibicao]="'ID Externo'" 
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-data-envio" scope="col">                
                <bn-ordenacao 
                  [ordenacao]="atributosOrdenacao" 
                  [atributo]="'dataEnvio'"
                  [nomeAtributoExibicao]="'Dt. envio'" 
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-data-contratacao" scope="col" class="mobile">
                <bn-ordenacao 
                  [ordenacao]="atributosOrdenacao" 
                  [atributo]="'dataContratacao'"
                  [nomeAtributoExibicao]="'Dt. ctr.'" 
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-val-financiamento" scope="col" class="titulo-moeda">
                Val. crédito
              </th>
              <th id="col-estado" scope="col">
                <bn-ordenacao 
                  [ordenacao]="atributosOrdenacao" 
                  [atributo]="'estado'"
                  [nomeAtributoExibicao]="'Estado'" 
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="fonte" id="pointer" *ngFor="let operacao of operacoesPaginadas" [routerLink]="['/operacoes', operacao.id]">
              <td *ngIf="!ehAgenteFinanceiro">
                <span *ngFor="let agente of agentesFinanceiros" >
                  {{ agente.nome == operacao?.detalhe?.nomeAgenteFinanceiro ? agente.sigla : null}} 
                </span>
              </td>
              <td id="nowrap">{{ operacao.id }} ({{ operacao.codigoTipoOperacao }})</td>
              
              <td><span >{{ operacao.codigoTipoOperacao == 'L' ? operacao.idOperacaoAgente : operacao.idProtocoloBNDES}}</span></td>
              
              <td>{{ operacao.dataEnvio | date: 'dd/MM/yy'}}</td>
              <td class="mobile">{{ operacao.dataContratacao | date: 'dd/MM/yy'}}</td>
              <td class="titulo-moeda">{{ operacao?.detalhe?.valorCredito | bnMask: 'MOEDA'}}</td>
              <td class="hover-hint">
                <span *ngFor="let i of tipoEstado" tabindex="0" [ngbTooltip]="i.nome">
                  {{ operacao?.detalhe?.estado?.id == i.codigo? i.sigla : null}} 
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </div>
</div>